<template>
  <v-filter-modal
    class="realty-filters-mobile"
    :active-menu-item.sync="activeMenuItem"
    :menu="$options.NAME_MENU_ITEM"
    :count="filtersCount"
    @apply="applyFilters"
    @reset="resetFilters"
    @close="closeFilters"
  >
    <div v-if="!activeMenuItem" class="realty-filters-mobile__sorts">
      <div class="realty-filters-mobile__tabs-wrapper-title">СОРТИРОВАТЬ ПО</div>
      <div class="realty-filters-mobile__radio-wrapper" body-scroll-lock-ignore>
        <v-radio
          v-for="option in $options.SORT_OPTIONS"
          :key="option.label"
          v-model="filtersParams.orderBy"
          class="realty-filters-mobile__radio"
          :value="option.value"
          >{{ option.label }}</v-radio
        >
      </div>
    </div>

    <div class="realty-filters-mobile__menu">
      <v-menu v-if="!activeMenuItem" v-model="activeMenuItem">
        <v-menu-item name="category">
          Категория
          <span class="realty-filters-mobile__menu-item-preview"> {{ preview.category }} </span>
        </v-menu-item>
        <v-menu-item name="advertStatus">
          Статус
          <span class="realty-filters-mobile__menu-item-preview"> {{ advertStatusPreview }} </span>
        </v-menu-item>
        <v-menu-item name="facingType">
          Отделка
          <span class="realty-filters-mobile__menu-item-preview"> {{ facingTypePreview }} </span>
        </v-menu-item>
        <v-menu-item name="dealType">
          Тип сделки
          <span class="realty-filters-mobile__menu-item-preview"> {{ dealTypePreview }} </span>
        </v-menu-item>
        <v-menu-item name="date">
          Дата публикации
          <span class="realty-filters-mobile__menu-item-preview"> {{ datePreview }} </span>
        </v-menu-item>
        <v-menu-item name="price">
          Цена
          <span class="realty-filters-mobile__menu-item-preview"> {{ pricePreview }} </span>
        </v-menu-item>
        <v-menu-item v-if="!isRoleOwner" name="agent">
          Агент
          <span class="realty-filters-mobile__menu-item-preview">
            {{ preview.agent }}
          </span>
        </v-menu-item>
      </v-menu>
    </div>

    <div v-if="!agentOptionsLoading" class="realty-filters-mobile__sections-wrapper">
      <div v-show="activeMenuItem === 'category'" class="realty-filters-mobile__select">
        <filters-select
          v-model="selectedCategory"
          :options="categoryOptions"
          class="realty-filters-mobile__list-item"
        />
      </div>
      <div v-show="activeMenuItem === 'advertStatus'" class="realty-filters-mobile__select">
        <filters-select
          v-model="selectedAdvertStatus"
          :options="advertStatusOptions"
          class="realty-filters-mobile__list-item"
        />
      </div>
      <div v-show="activeMenuItem === 'facingType'" class="realty-filters-mobile__select">
        <filters-select
          v-model="selectedFacingType"
          :options="facingTypeOptions"
          class="realty-filters-mobile__list-item"
        />
      </div>
      <div v-show="activeMenuItem === 'dealType'" class="realty-filters-mobile__select">
        <filters-select
          v-model="selectedDealType"
          :options="dealTypeOptions"
          class="realty-filters-mobile__list-item"
        />
      </div>
      <div v-show="activeMenuItem === 'agent'" class="realty-filters-mobile__select">
        <filters-select v-model="selectedAgent" :options="agentOptions" class="realty-filters-mobile__list-item" />
      </div>

      <v-filter-price
        v-show="activeMenuItem === 'price'"
        :price-gte.sync="filtersParams.priceGte"
        :price-lte.sync="filtersParams.priceLte"
      />
      <v-date-publication
        v-show="activeMenuItem === 'date'"
        :date-from.sync="filtersParams.dateFrom"
        :date-to.sync="filtersParams.dateTo"
      />
    </div>
  </v-filter-modal>
</template>

<script>
import VFilterModal from '@/components/common/VFilterModal.vue'
import VMenu from '@/components/common/VMenu.vue'
import VMenuItem from '@/components/common/VMenuItem.vue'
import VRadio from '@/components/common/VRadio.vue'
import FiltersSelect from '@/components/Agent/AgentsSelect.vue'
import { advertsService, agentsService } from '@/services/http'
import {
  DEAL_TYPE_OPTIONS,
  FACING_TYPE_OPTIONS,
  SORT_OPTIONS_MAP,
  STATUS_OPTIONS
} from '@/constants/objectRealtyOptions'
import { pluralizeNumeral } from '@/utils/pluralization'
import { formatDatePreview, formatMoney } from '@/utils/formatters'
import VDatePublication from '@/components/common/VDatePublication.vue'
import VFilterPrice from '@/components/common/VFilterPrice.vue'
import { mapGetters } from 'vuex'
import { MODULE_SESSION } from '@/store/modules/session/session.types'

function generateFilters() {
  return {
    categoryId: undefined,
    agentId: undefined,
    orderBy: '-id',
    dateTo: undefined,
    dateFrom: undefined,
    priceLte: undefined,
    priceGte: undefined,
    advertStatus: undefined,
    facingType: undefined,
    dealType: undefined
  }
}

function generatePreview() {
  return {
    agent: null,
    category: null
  }
}

const NAME_MENU_ITEM_MAP = {
  agent: 'Агент',
  price: 'Цена',
  date: 'Дата публикации',
  category: 'Категории',
  facingType: 'Отделка',
  dealType: 'Тип сделки',
  advertStatus: 'Статус'
}

export default {
  SORT_OPTIONS: SORT_OPTIONS_MAP,
  NAME_MENU_ITEM: NAME_MENU_ITEM_MAP,
  name: 'ObjectsRealtyFiltersMobile',
  components: {
    VFilterPrice,
    VDatePublication,
    VFilterModal,
    VRadio,
    VMenu,
    VMenuItem,
    FiltersSelect
  },
  props: {
    count: {
      type: Number,
      default: 0
    },
    defaultFilters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      agentOptions: [],
      activeMenuItem: undefined,
      categoryOptions: [],
      advertStatusOptions: STATUS_OPTIONS.map(status => {
        return { id: status.value, name: status.label }
      }),
      facingTypeOptions: FACING_TYPE_OPTIONS.map(type => {
        return { id: type.value, name: type.label }
      }),
      dealTypeOptions: DEAL_TYPE_OPTIONS.map(type => {
        return { id: type.value, name: type.label }
      }),
      agentOptionsLoading: false,
      categoryOptionsLoading: false,
      filtersParams: generateFilters(),
      preview: generatePreview()
    }
  },
  computed: {
    ...mapGetters({
      isRoleOwner: `${MODULE_SESSION}/isRoleOwner`
    }),
    selectedAdvertStatus: {
      get() {
        return { id: this.filtersParams.advertStatus }
      },
      set(status) {
        this.filtersParams.advertStatus = status?.id
        this.preview.advertStatus = status?.name
      }
    },
    selectedFacingType: {
      get() {
        return { id: this.filtersParams.facingType }
      },
      set(facingType) {
        this.filtersParams.facingType = facingType?.id
        this.preview.facingType = facingType?.name
      }
    },
    selectedDealType: {
      get() {
        return { id: this.filtersParams.dealType }
      },
      set(dealType) {
        this.filtersParams.dealType = dealType?.id
        this.preview.dealType = dealType?.name
      }
    },
    selectedCategory: {
      get() {
        return { id: this.filtersParams.categoryId }
      },
      set(category) {
        this.filtersParams.categoryId = category?.id
        this.preview.category = category?.name
      }
    },
    selectedAgent: {
      get() {
        return { id: this.filtersParams.agentId }
      },
      set(agent) {
        this.filtersParams.agentId = agent?.id
        this.preview.agent = agent?.name
      }
    },
    pricePreview() {
      if (this.filtersParams.priceGte || this.filtersParams.priceLte) {
        return `${formatMoney(this.filtersParams.priceGte) || '0'} - ${formatMoney(this.filtersParams.priceLte) ||
          '...'} ₽`
      }
      return null
    },
    datePreview() {
      return formatDatePreview(this.filtersParams.dateFrom, this.filtersParams.dateTo)
    },
    advertStatusPreview() {
      return this.advertStatusOptions.find(status => status.id === this.filtersParams.advertStatus)?.name
    },
    facingTypePreview() {
      return this.facingTypeOptions.find(type => type.id === this.filtersParams.facingType)?.name
    },
    dealTypePreview() {
      return this.dealTypeOptions.find(type => type.id === this.filtersParams.dealType)?.name
    },
    filtersCount() {
      const text = pluralizeNumeral(this.count, 'объект', 'объекта', 'объектов')
      return `${this.count} ${text}`
    }
  },
  watch: {
    defaultFilters: {
      immediate: true,
      handler({ status, page, ...newFilters }) {
        this.filtersParams = newFilters
      }
    },
    agentOptions() {
      this.preview.agent = this.agentOptions.find(agent => agent.id === this.filtersParams.agentId)?.name
    },
    categoryOptions() {
      this.preview.category = this.categoryOptions.find(category => category.id === this.filtersParams.categoryId)?.name
    }
  },
  created() {
    if (!this.isRoleOwner) this.selectAgents()
    this.selectCategory()
  },
  methods: {
    selectAgents() {
      this.agentOptionsLoading = true
      return agentsService
        .select()
        .then(agentList => {
          this.agentOptions = agentList
        })
        .finally(() => {
          this.agentOptionsLoading = false
        })
    },
    selectCategory() {
      this.categoryOptionsLoading = true
      return advertsService
        .selectCategory()
        .then(categories => {
          this.categoryOptions = categories
        })
        .finally(() => {
          this.categoryOptionsLoading = false
        })
    },
    changeOrder(orderBy) {
      this.filtersParams.orderBy = orderBy
    },
    closeFilters() {
      this.$emit('close')
    },
    resetFilters() {
      this.filtersParams = generateFilters()
      this.preview = generatePreview()
    },
    applyFilters() {
      this.$emit('apply-filters', { ...this.filtersParams })
    }
  }
}
</script>
